<template>
	<db-row class="action-sheet-wrapper" :valign="valign" @click="cancelHandler">
		<db-row height="auto" class="action-sheet-inner-wrapper" :class="[actionSheetClass, 'dir-' + valign]">
			<db-button type="danger" @click="cancelHandler" height="100" class="cancel-btn" :class="'cancel-btn-' + valign" width="100%" v-if="valign === ActionSheetDir.TOP.toLowerCase()">取消</db-button>
			<db-row height="auto" class="button-list-wrapper">
				<db-button @click="handler(button)" width="100%" height="100" class="sheet-button" v-for="(button, idx) in buttons" :key="idx">
					<db-label size="28" color="#333333" bold>{{button.text}}</db-label>
				</db-button>
			</db-row>
			<db-button type="danger" @click="cancelHandler" height="100" class="cancel-btn" :class="'cancel-btn-' + valign" width="100%" v-if="valign === ActionSheetDir.BOTTOM.toLowerCase()">取消</db-button>
		</db-row>
	</db-row>
</template>

<script>
	import {ActionSheet} from '../../../../model/Dialog'
	import {ActionSheetDir} from '../../../../enum'
	
	export default {
		name: 'action-sheet',
		
		props: {
			buttons: {
				type: Array,
				default(){
					return []
				}
			},
			
			cancel: {
				type: Boolean,
				default: true
			},
			
			dir: {
				type: String,
				default: ActionSheetDir.BOTTOM
			}
		},
		
		data(){
			return {
				ActionSheetDir: ActionSheetDir,
				actionSheetClass: 'action-sheet-init'
			}
		},
		
		computed: {
			valign(){
				return (this.dir === ActionSheetDir.BOTTOM) ? 'bottom' : 'top'
			}
		},
		
		mounted(){
			this.start()
		},
		
		methods: {
			cancelHandler(){
				this.close()
				event.stopPropagation()
			},
			
			async handler({handler}){
				event.stopPropagation()
				if(handler){
					await this.close()
					setTimeout(() => {
						handler(this.close)
					}, 100)
				}else{
					await this.close()
				}
			},

			async start(){
				return new Promise(res => {
					setTimeout(() => {
						this.actionSheetClass = 'action-sheet-active'
						setTimeout(async () => {
							res()
						}, 200)
					}, 50)
				})
			},
			
			async close(){
				return new Promise(res => {
					this.actionSheetClass = 'action-sheet-init'
					setTimeout(() => {
						this.$store.commit('mobileStore/removeDialog')
						res()
					}, 300)
				})
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	@import '../../../../assets/styles/vars.scss';
	
	.action-sheet-wrapper{
		background: transparent;
		
		.action-sheet-inner-wrapper{
			padding: 30px;
		}
		
		.cancel-btn{
			border-radius: 24px;
			
			&.cancel-btn-top{
				margin-bottom: 24px;
			}
			&.cancel-btn-bottom{
				margin-top: 24px;
			}
		}
		
		.button-list-wrapper{
			background: #fff;
			border-radius: 24px;
			overflow: hidden;
			
			.sheet-button{
				border-radius: 0;
				border-bottom: solid 1px #ccc;
				background: #FFFFFF;
				color: $btn_primary_color;
				padding: 0 30px;
				
				&:last-child{
					border: none;
				}
			}
		}
		
		.action-sheet-init{
			transition: all .2s;
			
			&.dir-bottom{
				transform: translateY(100%);
			}
			&.dir-top{
				transform: translateY(-100%);
			}
		}
		
		.action-sheet-active{
			transition: all .2s;
			
			&.dir-bottom{
				transform: translateY(0);
			}
			&.dir-top{
				transform: translateY(0);
			}
		}
	}
</style>
